import React from "react";
import { useLocation } from "react-router-dom";
import {
    StyledHeader,
    StyledSubTitle,
    StyledTitle,
} from "../../styles/MainStyles";

function AcademicActivityPlanHeader() {
    const location = useLocation();
    let title;
    let subtitle;

    if (location.pathname === "/editar-tach") {
        title = "Editar TACH (Termo de Acordo de Carga Horária)";
        subtitle =
            "Aqui você pode editar e visualizar os termos de acordo de carga horária criados";
    }

    if (location.pathname === "/consultar-tach") {
        title = "Consultar TACH (Termo de Acordo de Carga Horária)";
        subtitle =
            "Aqui você pode visualizar os termos de acordo de carga horária criados";
    }

    if (location.pathname === "/meu-tach") {
        title = "Meu TACH (Termo de Acordo de Carga Horária)";
        subtitle =
            "Aqui você pode criar, editar e visualizar os termos de acordo de carga horária criados";
    }

    return (
        <StyledHeader>
            <StyledTitle>{title}</StyledTitle>
            <StyledSubTitle>{subtitle}</StyledSubTitle>
        </StyledHeader>
    );
}

export default AcademicActivityPlanHeader;
